<div class="all_outer">
    <mat-card class="filter" >
        Kanban Board
    </mat-card>
    <div class="outer_col">
      
        <div class="col_holder">
            <div class="statusName">
                Status 1
            </div>
            <div class="col">
                <div class="card">
                    core one
                </div>
                <div class="card">
                    core two
                </div>
            </div>
        </div>

        <div class="col_holder">
            <div class="statusName">
                Status 2
            </div>
            <div class="col"></div>
        </div>
        
        <div class="col_holder">
            <div class="statusName">
                Status 3
            </div>
            <div class="col"></div>
        </div>

        <div class="col_holder">
            <div class="statusName">
                Status 4
            </div>
            <div class="col"></div>
        </div>
    </div>
</div>